import { render, staticRenderFns } from "./crudSurrender.vue?vue&type=template&id=e2fd1e84&"
import script from "./crudSurrender.vue?vue&type=script&lang=js&"
export * from "./crudSurrender.vue?vue&type=script&lang=js&"
import style0 from "./crudSurrender.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports